module.exports = __webpack_public_path__ + "static/2-668e2672a8aad64dffb3be6ed3f61b2c.jpg";